import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconResize: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"resize, layout, enlarge"} maskId="square-filled-radius-0-stroke-1-IconResize"><path d="M4 20H10V21H3V14H4V20Z" fill="currentColor"/><path d="M17 17H7V7H17V17Z" fill="currentColor"/><path d="M21 10H20V4H14V3H21V10Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconResize;
